export default __webpack_public_path__ + "static/media/hlr.f26cf830.svg";